<div class="wrapper">
  <div class="row">
    <div class="col-offset-9 col-3">
      <div mat-dialog-actions class="float-left">
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content class="pt-0">
    <div class="row">
      <div class="col-12">
        <p><strong>Title:</strong> {{ data.title }}</p>
        <p><strong>Status:</strong> {{ data.status }}</p>
        <p><strong>Start Time:</strong> {{ data.start | date : "short" }}</p>
        <p><strong>End Time:</strong> {{ data.end | date : "short" }}</p>
        <p><strong>Hospital:</strong> {{ data.hospital }}</p>
        <p><strong>Departamento:</strong> {{ data.department }}</p>
      </div>
    </div>
    <mat-card class="mb-25 tagus-card">
      <mat-card-header class="border-bottom">
        <h5 class="mb-0">Histórico</h5>
      </mat-card-header>
      <mat-card-content>
        <ul class="ps-0 mb-0 mt-0 list-unstyled tagus-timeline">
          <li class="position-relative" *ngFor="let timeline of data.timeline">
            <img
              src="assets/img/icon/right-arrow.png"
              alt="right-arrow"
              class="icon"
            />
            <h5 class="mb-12">{{ getTranslateStatusToBR(timeline.action) }}</h5>
            <span class="d-block muted-color mb-12 fs-14">{{
              timeline.createdAt | date : "short"
            }}</span>
            <p>{{ timeline.reason }}</p>
          </li>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>
</div>
